import { __extends } from "tslib";
import { addClass, getShadowElement, isDefined, removeClass, toggleElementPlaceholder } from '@tyler-components-web/core';
import { deepQuerySelectorAll } from 'shadow-utils';
import { BaseAdapter } from '../../core/adapters/base-adapter';
import { OMNIBAR_SEARCH_CONSTANTS } from './omnibar-search-constants';
import { toggleAttribute, toggleClass } from '../../core';
/**
 * Provides facilities for interacting with the internal DOM of `OmnibarSearchComponent`.
 */
var OmnibarSearchAdapter = /** @class */ (function (_super) {
    __extends(OmnibarSearchAdapter, _super);
    function OmnibarSearchAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._rootElement = getShadowElement(component, OMNIBAR_SEARCH_CONSTANTS.selectors.ROOT);
        _this._globalIconContainer = getShadowElement(component, OMNIBAR_SEARCH_CONSTANTS.selectors.GLOBAL_ICON_CONTAINER);
        _this._contextContainerElement = getShadowElement(component, OMNIBAR_SEARCH_CONSTANTS.selectors.CONTEXT_CONTAINER);
        return _this;
    }
    OmnibarSearchAdapter.prototype.initialize = function () {
        var inputElements = deepQuerySelectorAll(this._component, OMNIBAR_SEARCH_CONSTANTS.selectors.INPUT, false);
        if (inputElements.length) {
            this._inputElement = inputElements[0];
        }
    };
    OmnibarSearchAdapter.prototype.hasInputElement = function () {
        return isDefined(this._inputElement);
    };
    OmnibarSearchAdapter.prototype.addRootClass = function (className) {
        addClass(className, this._rootElement);
    };
    OmnibarSearchAdapter.prototype.removeRootClass = function (className) {
        removeClass(className, this._rootElement);
    };
    /**
     * Adds an event to the search input element.
     * @param {string} type The event type.
     * @param {Function} listener The event listener.
     */
    OmnibarSearchAdapter.prototype.addSearchInputEventListener = function (type, listener) {
        this._inputElement.addEventListener(type, listener);
    };
    /**
     * Removes an event from the search input element.
     * @param {string} type The event type.
     * @param {Function} listener The event listener.
     */
    OmnibarSearchAdapter.prototype.removeSearchInputEventListener = function (type, listener) {
        this._inputElement.removeEventListener(type, listener);
    };
    /**
     * Toggles the disabled attribute on the search input.
     * @param {boolean} disabled Whether the attribute should be set or not.
     */
    OmnibarSearchAdapter.prototype.setDisabled = function (disabled) {
        toggleClass(this._rootElement, disabled, OMNIBAR_SEARCH_CONSTANTS.classes.DISABLED);
        toggleAttribute(this._inputElement, disabled, OMNIBAR_SEARCH_CONSTANTS.attributes.DISABLED);
    };
    OmnibarSearchAdapter.prototype.getInputValue = function () {
        return this._inputElement.value;
    };
    OmnibarSearchAdapter.prototype.setInputValue = function (value) {
        this._inputElement.value = value;
    };
    OmnibarSearchAdapter.prototype.setInputPlaceholder = function (value) {
        this._inputElement.placeholder = value;
    };
    OmnibarSearchAdapter.prototype.setGlobalIconVisibility = function (isVisible) {
        this._globalIconPlaceholder = toggleElementPlaceholder(this._component, isVisible, OMNIBAR_SEARCH_CONSTANTS.elementName, OMNIBAR_SEARCH_CONSTANTS.selectors.GLOBAL_ICON_CONTAINER, this._globalIconContainer, this._globalIconPlaceholder);
    };
    OmnibarSearchAdapter.prototype.setContextVisibility = function (isVisible) {
        this._contextContainerPlaceholder = toggleElementPlaceholder(this._component, isVisible, OMNIBAR_SEARCH_CONSTANTS.elementName, OMNIBAR_SEARCH_CONSTANTS.selectors.CONTEXT_CONTAINER, this._contextContainerElement, this._contextContainerPlaceholder);
    };
    return OmnibarSearchAdapter;
}(BaseAdapter));
export { OmnibarSearchAdapter };
